<template lang="html">
  <div class="d-flex flex-column">

    <div class="cta-4 text-primary mb-2">Nouveau</div>
    <div class="text-alternate">{{ human_created_on }}</div>
    <div class="cta-5 mt-1">
      Publié le {{ context.data.published_on|local_date }}.<br>
      {{ human_published_on }}.
    </div>
  </div>
</template>

<script>
import moment from "moment";
moment.locale("fr");

export default {
  name: "StateNew",
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  computed: {
    human_published_on() {
      return moment(this.context.data.published_on).fromNow();
    },
    human_created_on() {
      return moment(this.context.created_on).fromNow();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
